
<div id="prueba" class="bannerCiudad">
    <h1 class="ciudadTitulo"><strong>Ciudades</strong></h1>
</div>


<section class="container-fluid medidas">
    <div class="row ">

        <div class="mt-5 mt-md-3 col-12 col-sm-12  col-md-6  pl-sm-5 pr-sm-5 pl-md-2 pr-md-2 col-lg-4 col-xl-3 contenedor8 ciudadCARD"
            *ngFor="let ciudad of ciudades">
            <div class="hover-overlay border rounded ciudadCARDin">
                <div class="contenedor contenedor2">
                    <a routerLink="/ciudades/eventos/{{ciudad.id}}" class="outerLink">
                        <img src="{{ciudad?.imagen.url}}" *ngIf="ciudad.imagen" class=" rounded  darkableImage oscurecer"
                           />
                        <div class="overlay"></div>
                        <p class="centrado2"><strong> Acá encontrarás los mejores eventos de la ciudad de
                                {{ciudad?.nombre}}. ¿Que estás esperando para comprar tu ticket?</strong></p>
                    </a>
                </div>
            </div>

            <div class="border rounded container-fluid ciudadCARDin2">

                <div class="row contenedor contenedorBot">
                    <div class="col-12">
                        <h2 class=" rounded titulos pt-3 pr-3 pl-3"><strong> <a class="titulos"
                                    routerLink="/ciudades/eventos/{{ciudad.id}}">{{ciudad?.nombre
                                    |resumir2}}</a></strong></h2>
                        <hr class="aaa">
                    </div>
                    <div class="col-6 border-right temperatura">
                        <p class="fechas"><strong>Temperatura Promedio: {{ciudad?.temperatura}} °C </strong></p>
                    </div>
                    <div class="col-6 botonVer">
                        <button class="action_button rounded-pill shadow texto bg-darkblue-gradient"
                            routerLink="/ciudades/eventos/{{ciudad.id}}">Ver</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</section>